import { useAtomValue } from 'jotai'
import { getFlag } from 'sierra-client/config/global-config'
import { reflectionsSummaryAtom } from 'sierra-client/state/settings'

export const useIsReflectionsSummaryEnabled = (): boolean => {
  const isFlagEnabled = getFlag('reflection-summary')
  const reflectionsSummary = useAtomValue(reflectionsSummaryAtom)
  return reflectionsSummary || isFlagEnabled
}
